import { apiSlice } from "../apiSlice";

export const expenseApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addSpending: builder.mutation({
      query: (data) => ({
        url: "/expenses/add-spending",
        method: "POST",
        body: data,
      }),
      invalidatesTags: () => [{ type: "expenses" }, { type: "currentCapital" }],
    }),

    getAllSpending: builder.query({
      query: ({
        page,
        size,
        to,
        from,
        amount,
        createdBy,
        paymentMethod,
        expenseDateEnd,
        spendingCategory,
        expenseDateStart,
      }) =>
        `/expenses?pageNo=${page}&pageSize=${size}&amount=${amount}&createdBy=${createdBy}&paymentMethod=${paymentMethod}&expenseDateEnd=${expenseDateEnd}&from=${from}&to=${to}&spendingCategory=${spendingCategory}&expenseDateStart=${expenseDateStart}`,

      keepUnusedDataFor: 600,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            {
              type: "expenses",
            },
          ];
        }
        return [{ type: "expenses" }];
      },
    }),
  }),
});

export const { useAddSpendingMutation, useGetAllSpendingQuery } = expenseApi;
